export default "__VITE_ASSET__C4iNTsXA__"